import Alert from './src/alert2.mjs';
export { alertEffects, alertEmits, alertProps } from './src/alert.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAlert = withInstall(Alert);

export { ElAlert, ElAlert as default };
//# sourceMappingURL=index.mjs.map
